import { Spin, Modal } from 'antd';
import { useState } from 'react';
import { useGetOrganizationsQuery } from '../../features/organization/organizationService';
import OrganizationCollapseView from '../../components/Organizations/OrganizationCollapseView';
import RoundedButton from '../../components/RoundedButton';
import OrganizationsNewTeamForm from './OrganizationsNewTeamForm';
import OrganizationsNewLocationForm from './OrganizationsNewLocationForm';
import AddNewOrganizationForm from './AddNewOrganizationForm';
import OrganizationPlaceOfService from '../../components/Organizations/OrganizationPlaceOfService';
import {
    HospiceLocationResponse,
    HospiceOrganizationWithDetailsResponse,
    HospiceTeamResponse,
    PlaceOfServiceResponse,
} from '../../models/OrganizationModels';

const OrganizationsView = () => {
    const [open, setOpen] = useState<boolean>(false);
    const [selectedLocation, setSelectedLocation] = useState<string>('');
    const [openLocationModal, setOpenLocationModal] = useState<boolean>(false);
    const [selectedOrganization, setSelectedOrganization] =
        useState<string>('');
    const { data: organizations, isLoading } = useGetOrganizationsQuery({});
    const [openNewOrgModal, setOpenNewOrgModal] = useState<boolean>(false);
    const [selectedLocationId, setSelectedLocationId] = useState<string>('');
    const [openPlaceOfServiceModal, setOpenPlaceOfServiceModal] =
        useState<boolean>(false);
    const [teamName, setTeamName] = useState<string>('');
    const [orgId, setOrgId] = useState<string>('');
    const [teamId, setTeamId] = useState<string>('');
    const [selectedPlaceOfService, setSelectedPlaceOfService] =
        useState<PlaceOfServiceResponse | null>(null);
    const [selectedTeam, setSelectedTeam] =
        useState<HospiceTeamResponse | null>(null);
    const [selectedLocationItem, setSelectedLocationItem] =
        useState<HospiceLocationResponse | null>(null);
    const [selectedOrganizationItem, setSelectedOrganizationItem] =
        useState<HospiceOrganizationWithDetailsResponse | null>(null);

    return (
        <Spin spinning={isLoading}>
            <h1 className="d-flex align-items-center justify-content-between mb-5">
                <div>Organizations</div>
                <RoundedButton
                    className="mt-2 me-2"
                    style={{
                        backgroundColor: 'var(--hcrx-light-blue)',
                        color: 'white',
                    }}
                    onClick={() => {
                        setSelectedOrganizationItem(null);
                        setOpenNewOrgModal(true);
                    }}
                >
                    Add New Organization
                </RoundedButton>
            </h1>
            {organizations && organizations?.length > 0 && (
                <OrganizationCollapseView
                    data={organizations}
                    openModal={setOpen}
                    setSelectedLocation={setSelectedLocation}
                    setOpenLocationModal={setOpenLocationModal}
                    setSelectedOrganization={setSelectedOrganization}
                    setSelectedLocationId={setSelectedLocationId}
                    setOpenPlaceOfServiceModal={setOpenPlaceOfServiceModal}
                    setTeamName={setTeamName}
                    setOrgId={setOrgId}
                    setTeamId={setTeamId}
                    setSelectedPlaceOfService={setSelectedPlaceOfService}
                    setSelectedTeam={setSelectedTeam}
                    setSelectedLocationItem={setSelectedLocationItem}
                    setOpenNewOrgModal={setOpenNewOrgModal}
                    setSelectedOrganizationItem={setSelectedOrganizationItem}
                />
            )}

            <Modal
                title={`${
                    selectedOrganizationItem
                        ? `Manage Organization: ${selectedOrganizationItem.hospiceName}`
                        : `Add New Organization`
                }`}
                centered
                className="new-team-modal my-3"
                open={openNewOrgModal}
                footer={null}
                onOk={() => {
                    setOpenNewOrgModal(false);
                    setSelectedOrganizationItem(null);
                }}
                onCancel={() => {
                    setOpenNewOrgModal(false);
                    setSelectedOrganizationItem(null);
                }}
                destroyOnClose
                width={1200}
            >
                <AddNewOrganizationForm
                    setOrgModalOpen={setOpenNewOrgModal}
                    selectedOrganization={selectedOrganizationItem}
                    setSelectedOrganizationItem={setSelectedOrganizationItem}
                />
            </Modal>

            
            <Modal
                title={`${
                    selectedLocationItem
                        ? `Manage Location: ${selectedLocationItem.description}`
                        : `Add New Location to ${selectedOrganization}`
                }`}
                centered
                className="new-team-modal my-3"
                open={openLocationModal}
                footer={null}
                onOk={() => {
                    setOpenLocationModal(false);
                    setSelectedLocationItem(null);
                }}
                onCancel={() => {
                    setOpenLocationModal(false);
                    setSelectedLocationItem(null);
                }}
                destroyOnClose
                width={1000}
            >
                <OrganizationsNewLocationForm
                    orgId={orgId}
                    selectedLocation={selectedLocationItem}
                    closeModal={setOpenLocationModal}
                    setSelectedLocation={setSelectedLocationItem}
                />
            </Modal>

            <Modal
                title={`${
                    selectedTeam
                        ? `Manage Team: ${selectedTeam.teamName}`
                        : `Add New Team to ${selectedLocation}`
                }`}
                centered
                className="new-team-modal my-3"
                open={open}
                footer={null}
                onOk={() => {
                    setOpen(false);
                    setSelectedTeam(null);
                }}
                onCancel={() => {
                    setOpen(false);
                    setSelectedTeam(null);
                }}
                destroyOnClose
                width={1200}
            >
                <OrganizationsNewTeamForm
                    selectedLocationId={selectedLocationId}
                    selectedTeam={selectedTeam}
                    setTeamModalOpen={setOpen}
                    setSelectedTeam={setSelectedTeam}
                />
            </Modal>
            
            <Modal
                title={`${
                    selectedPlaceOfService
                        ? `Manage Place of Service: ${selectedPlaceOfService.name}`
                        : `Add New Place of Service to ${teamName}`
                }`}
                centered
                className="new-team-modal my-3"
                open={openPlaceOfServiceModal}
                footer={null}
                onOk={() => {
                    setOpenPlaceOfServiceModal(false);
                    setSelectedPlaceOfService(null);
                }}
                onCancel={() => {
                    setOpenPlaceOfServiceModal(false);
                    setSelectedPlaceOfService(null);
                }}
                destroyOnClose
                width={1000}
            >
                <OrganizationPlaceOfService
                    teamId={teamId}
                    placeOfService={selectedPlaceOfService}
                    closeModal={setOpenPlaceOfServiceModal}
                />
            </Modal>
        </Spin>
    );
};

export default OrganizationsView;
